module.exports = __webpack_public_path__ + "img/project10_8.jpg.ef41afc1.webp";